/* global process */
import { setContext } from '@apollo/client/link/context';
import { createHttpLink } from '@apollo/client/link/http';
import { ApolloClient } from '@apollo/client/core/ApolloClient';

import { cache } from './cache';

const httpLink = createHttpLink({
  uri: process.env.https://louisville.astrumu.io/business/graphql
});

function getClient(accessToken: string) {
  const authLink = setContext((_, { headers = {} }) => ({
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : ''
    }
  }));

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache
  });
}

export default getClient;
